export default __webpack_public_path__ + "static/asim_zeeshan-5f31c02e5ab54a1e14ebf061da647119.png";